import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query"

/**/
import { UseMutationsParams, AlertSeverityEnum } from "@/shared/interfaces";
import { useUiStore } from '@/store/ui';
import { NavigateFunction } from 'react-router-dom';
/* */


import { urlBackend } from '@/shared/constants/networking.constants';
import { erpApi } from "@/shared/axios";
import { Responsablev2, Responsablev2DataPagingRes } from "@/shared/interfaces/erp/administration/responsablev2.interface";
const {get,post,put, remove} = erpApi();

export const UseFetchResponsablev2 = (page = 1, nombre = '', page_size = 10) => {
    return useQuery({
        queryKey: ['responsable', page, nombre],
        queryFn: async () => {
            return getResponsablev2Fetch({page,page_size});
        }
    });
}

export const getResponsablev2Fetch = async(params?: getResponsableParamsv2) =>{
    const stateParams = {...params}
      if (stateParams.filterByState === false && stateParams.estado === undefined) {
            delete stateParams.estado;
        } else if (stateParams.filterByState !== false) {
            stateParams.estado = true;
        }
    delete stateParams.filterByState;

    const queryParams = getUrlParamsFetch(stateParams);
   
    return get<Responsablev2DataPagingRes>(
            
            `${urlBackend}api/v1/responsable/?${queryParams}`,
               true
    );
}

export type getResponsableParamsv2 = Partial<Responsablev2> & {
  page?: number;
  page_size?: number;

  filterByState?: boolean;
};

/***METODOS PARA CRUD */
export const useFetchResponsablev2 = (
  params?: GetResponsablev2Params,
  enabled = true
) => {
  return useQuery({
    queryKey: ["responsablev2", ...Object.values(params ?? {})],
    queryFn: async () => {
      return getResponsablev2(params);
    },
    enabled,
  });
};

export const useGetResponsablev2 = (id: string) => {
  return useQuery({
    queryKey: ["responsablev2", id],
    queryFn: async () => {
      return getResponsablev2ById(id);
    },
  });
};


export const useCreateResponsablev2 = ({
  navigate,
  enableRedirect = true,
  returnUrl,
  returnErrorUrl,
  enableErrorRedirect = false,
  customMessageErrorAlert,
  enableSuccessAlert = true,
  customSuccessMessage,
}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: createResponsablev2,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["responsablev2"] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableSuccessAlert &&
        setAlert(
          true,
          customSuccessMessage ?? "Responsable creado correctamente",
          AlertSeverityEnum.success
        );
    },
    onError: (error) => {
      enableErrorRedirect &&
        navigate &&
        returnUrl &&
        navigate(returnErrorUrl ?? returnUrl);

      handleAxiosError(error, customMessageErrorAlert);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useUpdateResponsablev2 = (
  navigate: NavigateFunction,
  returnUrl: string
) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({
    mutationFn: updateResponsablev2,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["responsablev2"] });
      navigate(returnUrl);
    },
    onError: (error) => {
      handleAxiosError(error);
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    },
  });
};

export const useDeleteResponsableV2 = () =>{
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteResponsableV2,
    onSuccess: () =>{
      queryClient.invalidateQueries({queryKey: ['responsablev2']})
    },
    onError: () =>{

    },
  })
}

export type GetResponsablev2Params = Partial<Responsablev2> & {
  page?: number;
  page_size?: number;
  filterByState?: boolean;
};

export type CreateResponsablev2Params = Omit<
  Responsablev2,
  "id_responsable" | "fecha_creacion" | "fecha_modificacion"
>;

export type UpdateResponsablev2Params = {
  id: string;
  data: CreateResponsablev2Params;
};


export const getResponsablev2 = async (
  params?: GetResponsablev2Params
) => {
  const stateParams = { ...params };

  if (
    stateParams?.filterByState === false &&
    stateParams?.estado === undefined
  ) {
    delete stateParams.estado;
  } else if (stateParams?.filterByState !== false) {
    stateParams.estado = true;
  }

  delete stateParams?.filterByState;

  const queryParams = getUrlParamsFetch(stateParams);

  return await get<Responsablev2DataPagingRes>(
    `${urlBackend}api/v1/responsable/?${queryParams}`,
    true
  );
};

export const getResponsablev2ById = async (id: string) => {
  const setAlert = useUiStore.getState().setAlert;

  const res = await get<Responsablev2>(
    `${urlBackend}api/v1/responsable/${id}/`,
    true
  );

  res.status === "error" && setAlert(true, res.message, res.status);

  return res;
};

export const createResponsablev2 = async (
  data: CreateResponsablev2Params
) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return post<Responsablev2>(
    `${urlBackend}api/v1/responsable/`,
    data,
    true
  );
};

export const updateResponsablev2 = async ({
  id,
  data,
}: UpdateResponsablev2Params) => {
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  setIsGlobalLoading(true);

  return put<Responsablev2>(
    `${urlBackend}api/v1/responsable/${id}/`,
    data,
    true
  );
};


export const deleteResponsableV2 = async(id:string) =>{
  const setAlert = useUiStore.getState().setAlert;
  const res = await remove<Responsablev2>(
    `${urlBackend}api/v1/responsable/${id}/`,true
  )
  setAlert(true,res.message,res.status)
  return res
}